import { colors } from '@galapagos/design-system/colors';
import { spacing } from '@galapagos/design-system/spacing';
import { typography } from '@galapagos/design-system/typography';

export const SIGNUP_IDENTITY_STYLE_ID = 'signup-identity-style';

/**
 * Layout for the identity steps' field groups and the code screen's help line.
 * Every value is a design-system token.
 */
export function signupIdentityCss(): string {
  const help = typography.b3Regular;
  return `
.signup-fields { display: flex; flex-direction: column; gap: ${spacing.m}px; }
.signup-code-help { display: flex; flex-direction: column; align-items: flex-start; gap: ${spacing.s}px; }
.signup-code-help__prompt { margin: 0; color: ${colors.text.secondary}; font-family: ${help.fontFamily}; font-weight: ${help.fontWeight}; font-size: ${help.fontSize}px; line-height: ${help.lineHeight}px; }
`;
}

/** Injects the identity stylesheet once per document. No-op during prerender. */
export function ensureSignupIdentityStyle(): void {
  if (typeof document === 'undefined' || document.getElementById(SIGNUP_IDENTITY_STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = SIGNUP_IDENTITY_STYLE_ID;
  style.textContent = signupIdentityCss();
  document.head.appendChild(style);
}
